import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table, Space, Button, message, Modal, Input } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import { getSowAbbrPaginationListNew } from "services/redux/officeresource/sowabbr/action";
import { isEmpty } from "lodash";
import { LogoImage } from "utils/imageConstants";

const ContactLabelAddUpdateTable = ({
  showAddUpdateCountryDrawer,
  startDate,
  endDate,
}) => {
  const [expandedTextVisible, setExpandedTextVisible] = useState(false);
  const [selectedExpandedText, setSelectedExpandedText] = useState("");
  const [cardData, setCardData] = useState({});
  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [searchQuery, setSearchQuery] = useState(""); // Added state for search query
  const pageSize = 1000;

  const dispatch = useDispatch();
  const { SowDetails, addSowLoading } = useSelector(
    (state) => state.sowAbbrReducer
  );

  const columns = [
    {
      title: "S No",
      dataIndex: "sno",
      key: "sno",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Title",
      dataIndex: "abbr",
      key: "abbr",
      sorter: true,
    },
    {
      title: "Expanded Text",
      dataIndex: "expandedText",
      key: "expandedText",
      render: (text) => {
        return (
          <>
            {text.map((item, index) => (
              <span style={{ marginRight: "5px" }} key={index}>
                {item}
                {index < text.length - 1 ? ", " : null}
              </span>
            ))}
          </>
        );
      },
    },

    {
      title: "Action",
      key: "action",
      render: (record) => (
        <Button type="link" onClick={() => handleEditClick(record)}>
          Edit
        </Button>
      ),
    },
  ];

  const handleViewClick = (expandedText) => {
    setSelectedExpandedText(expandedText);
    setExpandedTextVisible(true);
  };

  const handleEditClick = (record) => {
    showAddUpdateCountryDrawer(record);
  };

  useEffect(() => {
    getData();
  }, [startDate, endDate]);

  useEffect(() => {
    if (!isEmpty(SowDetails?.items)) {
      setData(SowDetails.items);
      setTotalCount(SowDetails.totalCount);

      if (SowDetails.items.length > 0) {
        fetchSowAbbrDetails(SowDetails.items[0].id);
      }
    } else {
      setData([]);
      setTotalCount(0);
    }
  }, [SowDetails]);

  const fetchSowAbbrDetails = async (id) => {
    try {
      const resp = await getSowAbbrPaginationListNew(id);
      if (resp) {
        console.log("SowAbbr details:", resp);
        setCardData(resp.data);
      }
    } catch (err) {
      message.error("Failed to fetch SowAbbr details");
    }
  };

  const getData = async (
    MaxResultCount = pageSize,
    SkipCount = 0,
    Sorting,
    SortType
  ) => {
    console.log("Fetching data with:", {
      MaxResultCount,
      SkipCount,
      Sorting,
      SortType,
    });
    try {
      const response = await dispatch(
        getSowAbbrPaginationListNew(
          { MaxResultCount, SkipCount, Sorting, SortType },
          searchQuery
        )
      );
      // console.log("API response:", response);
      if (response) {
        // console.log("API Response:", response);
        setData(response.items);
        setTotalCount(response.totalCount);
      }
    } catch (error) {
      message.error("Failed to fetch data");
    }
  };

  const handleTableChange = (pagination, filters, sorter) => {
    console.log("Table change triggered:", { pagination, filters, sorter });
    const Sorting = sorter.field;
    const SortType = sorter.order === "ascend" ? "asc" : "desc";
    const MaxResultCount = pagination.pageSize;
    const SkipCount = (pagination.current - 1) * pagination.pageSize;
    console.log("Calling getData with:", {
      MaxResultCount,
      SkipCount,
      Sorting,
      SortType,
    });
    getData(MaxResultCount, SkipCount, Sorting, SortType);
    console.log("getData called");
  };

  const handleSearch = () => {
    getData();
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "16px",
        }}
      >
        <Input
          placeholder="Search by Abbr"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onPressEnter={handleSearch}
          style={{ width: 200 }}
        />
        <Button
          type="primary"
          onClick={handleSearch}
          style={{
            marginLeft: "8px",
            backgroundColor: "green",
            borderColor: "green",
            color: "white",
          }}
        >
          Search
        </Button>
      </div>

      <Table
        className="organizer__tables"
        columns={columns}
        rowKey="id"
        dataSource={data}
        // onChange={handleTableChange}
        loading={{
          indicator: (
            <img
              src={LogoImage}
              height="auto"
              width="50px"
              backgroundColor="green"
            />
          ),
          spinning: addSowLoading,
        }}
        // pagination={{
        //   total: totalCount,
        //   pageSize: pageSize,
        //   showSizeChanger: false,

        //   onShowSizeChange: (current, size) => {
        //     getData(size, (current - 1) * size);
        //   },
        // }}
        pagination={10}
      />

      <Modal
        title="Expanded Text"
        visible={expandedTextVisible}
        onCancel={() => setExpandedTextVisible(false)}
        footer={null}
      >
        <div>
          {typeof selectedExpandedText === "string" ? (
            <p>{selectedExpandedText}</p>
          ) : Array.isArray(selectedExpandedText) ? (
            <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
              {selectedExpandedText.map((item, index) => (
                <li key={index}>
                  {typeof item === "object" ? (
                    <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                      {Object.entries(item).map(([key, value]) => (
                        <li key={key}>
                          <strong>{key}: </strong>
                          {Array.isArray(value) ? value.join(", ") : value}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    item
                  )}
                </li>
              ))}
            </ul>
          ) : (
            <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
              {selectedExpandedText &&
                Object.entries(selectedExpandedText).map(([key, value]) => (
                  <li key={key}>
                    <strong>{key}: </strong>
                    {Array.isArray(value) ? (
                      <ul
                        style={{ listStyleType: "disc", paddingLeft: "20px" }}
                      >
                        {value.map((item, idx) => (
                          <li key={idx}>{item}</li>
                        ))}
                      </ul>
                    ) : (
                      value
                    )}
                  </li>
                ))}
            </ul>
          )}
        </div>
      </Modal>
    </>
  );
};

export default ContactLabelAddUpdateTable;
